<h3>{{title}}</h3>
<div class="form-group has-search mt-2">
  <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
  <input type="text" name="search" [ngModel]="searchProfiles()" (ngModelChange)="searchProfiles.set($event)" class="form-control" placeholder="Search by username, email, address" autocomplete="off">
</div>

<div class="container">
  <div class="col-md-12">
    <div class="row">
      <div class="col-sm divth">
        Username
      </div>
      <div class="col-sm divth">
        Full Name
      </div>
      <div class="col-sm divth">
        Apt/Lot Number
      </div>
      <div class="col-sm divth">
        Email
      </div>
      <div class="col-sm divth">
        Action(s)
      </div>
    </div>
  </div>

  @for (userprofile of userprofiles() | paginate: { itemsPerPage: 25, currentPage: p() } | filter:searchProfiles(); track userprofile) {
    <div class="col-md-12">
      <div class="row">
        <div class="col-sm divtd">
          {{userprofile.username}}
        </div>
        <div class="col-sm divtd">
          {{userprofile.fullname}}
        </div>
        <div class="col-sm divtd">
          {{userprofile.apartmentnumber}}
        </div>
        <div class="col-sm divtd" >
          {{userprofile.email}}
        </div>
        <div class="col-sm divtd">
          <button (click)="openProfileDiv(userprofile.username)" class="acbtn btn btn-primary mx-1 my-1">@if (!userprofile.opened && help()) {
            <span class="mr-2">View</span>
            }@if (userprofile.opened && help()) {
            <span class="mr-2">Hide</span>
            }@if (!userprofile.opened) {
            <fa-icon [icon]="faEye"></fa-icon>
            }@if (userprofile.opened) {
            <fa-icon [icon]="faEyeSlash"></fa-icon>
          }</button>
          <button (click)="open('autofocus')"  class="acbtn btn btn-success mx-1 my-1">@if (help()) {
            <span class="mr-2">Message</span>
            }<fa-icon [icon]="faPaperPlane"></fa-icon> </button>
            <button (click)="sendWhatsapp(userprofile.phone)" class="btn btn-success mx-1 my-1">@if (help()) {
              <span class="mr-2">Whatsapp</span>
              } <fa-icon [icon]="faWhatsapp"></fa-icon></button>
              <button (click)="toggleHelp()" class="btn btn-info mx-1 my-1">@if (help()) {
                <span class="mr-2">Help</span>
                } @if (!help()) {
                <fa-icon [icon]="faQuestionCircle"></fa-icon>
                } @if (help()) {
                <fa-icon [icon]="faEyeSlash"></fa-icon>
              }</button>
            </div>
          </div>
          @if (userprofile.opened) {
            <div class="row divdetail">
              <div class="form-group col-sm-4">
                <label for="">Address</label>
                <div class="input-group mb-2 ">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><fa-icon [icon]="faMapMarkedAlt"></fa-icon></div>
                  </div>
                  <input [disabled]="true" type="text" [value]="userprofile.address" class="form-control py-0" name="address" id="address"   >
                </div>
              </div>
              @if (userprofile.blockname || userprofile.blockname != 'N/A') {
                <div class="form-group col-sm-4">
                  <label for="">Block Name</label>
                  <div class="input-group mb-2 ">
                    <div class="input-group-prepend">
                      <div class="input-group-text"><fa-icon [icon]="faMapSigns"></fa-icon></div>
                    </div>
                    <input [disabled]="true" type="text" [value]="userprofile.blockname" class="form-control py-0" name="blockname" id="blockname"   >
                  </div>
                </div>
              }
              <div class="form-group col-sm-4" >
                <label for="">Apartment/Lot Number</label>
                <div class="input-group mb-2 ">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><fa-icon [icon]="faMapPin"></fa-icon></div>
                  </div>
                  <input [disabled]="true" type="text" [value]="userprofile.apartmentnumber" class="form-control py-0" name="apartmentnumber" id="apartmentnumber"   >
                </div>
              </div>
              <div class="form-group col-sm-4">
                <label for="phone">Phone Number</label>
                <div class="input-group mb-2 ">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><fa-icon [icon]="faPhone"></fa-icon></div>
                  </div>
                  <input [disabled]="true" type="text" [value]="userprofile.phone" class="form-control py-0" name="phone" id="phone"   >
                </div>
              </div>
              <div class="form-group col-sm-4">
                <label for="exampleInputEmail1">Email address</label>
                <div class="input-group mb-2 ">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><fa-icon [icon]="faEnvelope"></fa-icon></div>
                  </div>
                  <input [disabled]="true" type="email" [value]="userprofile.email" class="form-control py-0" name="email" id="email"   >
                </div>
              </div>
            </div>
          }
        </div>
      }
      <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="p.set($event)"></pagination-controls>
    </div>


    <!-- <div class="col-md-12 profile-item inline" *ngFor="let userprofile of userprofiles | filter:searchProfiles">

    <div class="col-sm-2 d-elem">{{userprofile.username}}</div>
    <div class="col-sm-3 d-elem">{{userprofile.fullname}}</div>
    <div class="col-sm-3 d-elem">{{userprofile.address}}, {{userprofile.apartmentnumber}}</div>
    <div class="col-sm-2 d-elem">{{userprofile.email}}</div>
    <button class="btn btn-primary d-elem " type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
      Expand
    </button>

    <div class="collapse" id="collapseExample">
      <div class="card card-body">
        <div class="col-md-6">
          {{userprofile.address}}
          {{userprofile.apartmentnumber}}
        </div>
        <div class="col-md-6">
          <p>{{userprofile.email}}</p>
          <p>{{userprofile.phone}}</p>
        </div>
      </div>
    </div>
  </div> -->
